import React from 'react';
import './MilestoneIntCard.css';
import {
	tutorDetailsMilestonesConfig,
	globalColors,
} from './tutorDetailsMilestonesConfig';

function MilestoneIntCard(props) {
	const {
		mileStoneData,
		index,
		activeState
	} = props;
	const text = tutorDetailsMilestonesConfig.text || {};
	const colors = tutorDetailsMilestonesConfig.colors || {};
	const backgrounds = tutorDetailsMilestonesConfig.backgrounds || {};
	const milestoneStyle = {
		'--milestones-card-heading': colors.card_heading || '#86E5A5',
		'--milestones-completed-timeline': globalColors.success_color || '#0D913E',
		'--milestones-status-text': globalColors.white_text || '#fff',
		'--milestones-completed-card-gradient': backgrounds.completed_card_gradient || 'linear-gradient(180deg, rgba(8, 151, 68, 0.8) 0%, rgba(16, 108, 43, 0) 148.08%)',
	};
	let overlayPercent = 100 - parseInt(mileStoneData?.percentage) + '%';
	return (
		<div className={'milestoneCard ' + (
			activeState === 'notStarted' ? 'notStarted'
				: activeState === 'ongoing' ? 'ongoing'
					: activeState === 'complete' ? 'completed' : '')}
				 key={index}
				 style={milestoneStyle}
		>
			<div className="milestoneCardContent">
				<div className="milestoneCardHeader">
					<div className="h2">{mileStoneData?.heading}</div>
					<div className="h3">{
						activeState === 'complete' ? (text.completed_label || 'Complete'):
							activeState === 'ongoing' ? mileStoneData?.text : ''}
					</div>
				</div>
				<div className="milestoneCardDrawer">
					<div className="milestoneCardInner">
						<img src={mileStoneData?.imgUrl} alt="milestoneImg"/>
						<span className="milestoneCardOverlay" style={{ width: overlayPercent }}></span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MilestoneIntCard;
